export default () => {
    return null;
};
//# sourceMappingURL=feedback.js.map